import { render, staticRenderFns } from "./refining.vue?vue&type=template&id=70d28c4c&scoped=true"
import script from "./refining.vue?vue&type=script&lang=js"
export * from "./refining.vue?vue&type=script&lang=js"
import style0 from "./refining.vue?vue&type=style&index=0&id=70d28c4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d28c4c",
  null
  
)

export default component.exports